
export enum PayformStatusCd {
	APPROVED = 'Approved',
	DELETED = 'Deleted',
	NEW = 'New',
	RETURNED = 'Returned',
	SUBMITTED = 'Submitted',
	TRANSMITTED = 'Transmitted'}

